// Copyright (c) 2016 Deere & Company

import React, {PropTypes} from 'react';
import KeyValuePair from '@deere/cps-it.warranty-model-factory/lib/key-value-pair';
import LabeledKeyValueDropDown from '../../../../claim/shared/components/claim-fields/labeled-key-value-dropdown';

function handleClaimTypeSelect(event) {

    this.handleClaimTypeSelect(event.target.value);

}

const ClaimHistoryClaimTypesCriteria = props =>
    <div className='claim-history-claim-types-criteria'>
        <LabeledKeyValueDropDown
            className='claim-types-criteria'
            isEditable={true}
            label='SELECT_CLAIM_TYPE'
            list={props.claimTypes}
            onChange={props::handleClaimTypeSelect}
            selectedValue={props.selectedClaimType}
        />
    </div>;

ClaimHistoryClaimTypesCriteria.displayName = 'ClaimHistoryClaimTypesCriteria';
ClaimHistoryClaimTypesCriteria.propTypes = {
    claimTypes: PropTypes.arrayOf(PropTypes.instanceOf(KeyValuePair).isRequired),
    handleClaimTypeSelect: PropTypes.func.isRequired,
    selectedClaimType: PropTypes.instanceOf(KeyValuePair).isRequired
};

export default ClaimHistoryClaimTypesCriteria;



// WEBPACK FOOTER //
// ./src/reports/claim-history/components/claim-history-report-criteria/claim-types-criteria.js